import { render, staticRenderFns } from "./CatalogCollections.vue?vue&type=template&id=7f055414"
import script from "./CatalogCollections.vue?vue&type=script&lang=ts"
export * from "./CatalogCollections.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementSnapSlider: require('/codebuild/output/src3458403893/src/acredo-website/components/element/elementSnapSlider.vue').default})
